<template>
  <Panel>
    <template #header>
      <span data-cy="heading">Multi-Factor Authentication</span>
    </template>

    <template #content>
      <div>
        <BaseButtonLoader
          id="button-setup-mfa"
          data-cy="button-setup-mfa"
          label="Software based MFA"
          internal-platform-input
          button-class="custom-button--white-hover-grad pulse"
          type="button"
          horizontal
          @click="showSetup = true"
        >
          Setup
        </BaseButtonLoader>

        <b-row v-if="showSetup">
          <b-col
            cols="12"
            class="mt-3"
          >
            <SoftwareMFA @success="showSetup = false" />
          </b-col>
        </b-row>
      </div>
    </template>
  </Panel>
</template>

<script>
import { mapActions } from 'vuex'

import SoftwareMFA from '@/components/account/SoftwareMFA.vue'

export default {
  name: 'TwoFactorAuth',

  components: {
    SoftwareMFA
  },

  data() {
    return {
      showSetup: false
    }
  },
  created() {
    this.resetMFAKey()
  },
  methods: {
    ...mapActions('auth', ['resetMFAKey'])
  }
}
</script>

<style lang="scss" scoped></style>
